import React, { useState, useEffect } from 'react';
import { GetPrevNextPost } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const PrevNextPost = (postSlugObject) => {
  const [nextlink, setNextlink] = useState('');
  const [prevlink, setPrevlink] = useState('');
  const [nexttitle, setNextTitle] = useState('');
  const [prevtitle, setPrevTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleBlogClick = () => navigate('/blog/:paramlink');


  const handleNavigation = (slug, e) => {
    if (!slug) {
      e.preventDefault();
      return;
    }
    navigate(`/blog/${slug}`);
  };

  const fillPrevNextPost = async () => {
    try {
      const prevNextPostList = await GetPrevNextPost(postSlugObject.postSlug);
      const jsonPostList = JSON.parse(prevNextPostList);
      setNextlink(jsonPostList.nextlink);
      setPrevlink(jsonPostList.prevlink);
      setNextTitle(jsonPostList.nexttitle);
      setPrevTitle(jsonPostList.prevtitle);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  };

  useEffect(() => {
    fillPrevNextPost();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div class="row align-items-center">
      <div class="col-lg-6 col-sm-6">
        <div class="prev-post">
          <a href={prevlink ? `/blog/${prevlink}` : "#"}
            className={`${!prevlink ? "disabled" : ""}`}
            onClick={prevlink ? handleBlogClick : (e) => e.preventDefault()}
          >
            <i class="bx bx-left-arrow-alt"></i>
            Previous post
          </a>
        </div>
      </div>

      <div class="col-lg-6 col-sm-6">
        <div class="next-post">
          <a href={nextlink ? `/blog/${nextlink}` : "#"}
            className={`${!nextlink ? "disabled" : ""}`}
            onClick={nextlink ? handleBlogClick : (e) => e.preventDefault()}
          >
            Next post
            <i class="bx bx-right-arrow-alt"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PrevNextPost;